import React, { useState } from "react";
import { object, string, bool } from "prop-types";
import get from "lodash/get";

import { Link } from "@quintype/components";
import { SectionTag } from "@quintype/arrow";
import CardImage from "../../atoms/card-image";
import TimeStamp from "../../atoms/time-stamp";
import SocialShareBottom from "../../story-templates/social-share";
import { isFreeLimit } from "../../utils/isFreeLimit";
import useStorage from "../../../hook/useStorage";
import LightBoxImage from "../../molecules/lightBox-image";
import "./story-header-native-ad.m.css";
import aspectRatio from "../../utils/aspectRatio";


const StoryHeader = ({ story, isHeroImage = true }) => {
  const [showPopup, setShowPopup] = useState(false);
  const togglePopup = (isPopupOpen) => {
    setShowPopup(isPopupOpen);
  }
  const imgS3keys = story["hero-image-s3-key"];
  const authorSlug = get(story, ["authors", 0, "slug"], "");
  const authorName = get(story, ["authors", 0, "name"], story["author-name"]);
  const paikkakunta = get(story, ["metadata", "paikkakunta"], []);
  const sectionId = get(story, ["sections", "0", "id"]);
  //const sponsoredBy = storyObj.metadata?storyObj.metadata["sponsored-by"]:undefined;
  const sponsoredBy = get(story, ["metadata", "sponsored-by"]);
  const ingressi = get(story, ["metadata", "ingressi"], []);


  const accessType = story.access;
  const [checkUser, activeProducts,whiteListed,allTagIds,visitCounts,articlesLimit,isVisitedSlug] = useStorage();
  const conditionalComponents = isFreeLimit(checkUser, activeProducts,visitCounts,articlesLimit,isVisitedSlug);

  /* getting url right regarding different papers*/

  function findByKey(key, value) {
    return (item, i) => item[key] === value
  }

  let findParams = findByKey("domain-slug", "ilkka-pohjalainen") //change here
  let positionOfPaper = story.sections.findIndex(findParams)

  // Check if there is section for that paper (needed mainly for localhost)
  var sectionUrl = story.sections[positionOfPaper] ? (story.sections[positionOfPaper]["section-url"]) : (story.sections[0]["section-url"])
  var sectionTag = story.sections[positionOfPaper] ? (story.sections[positionOfPaper]["display-name"]) : (story.sections[0]["display-name"])
  const aspRto= aspectRatio(story);
  return (
    <div styleName="wrapper">
      <div styleName="section-time">
        <Link href={sectionUrl}>
          <div styleName="section-tag">{sectionTag}</div>
        </Link>
        <div styleName="sponsored-by">{sponsoredBy}</div>
      </div>
      {/* voice intuitive button for all in native ads */}
      <div className="voice-intuitive" styleName="voice-intuitive-btn"></div>
      <div styleName="headline-wrapper">
        <h1 styleName="story-headline">{story.headline}</h1>
      </div>
      <div styleName="story-lead">{ingressi}</div>
      {isHeroImage && (
        <React.Fragment>
          {imgS3keys && <div styleName="card-img" onClick={() => { togglePopup(true) }}>
            <CardImage aspectRatio={[aspRto[1],aspRto[0]]} story={story} defaultWidth={500} imageType="imageOriginalShape" />
          </div>}
          {(story["hero-image-caption"] || story["hero-image-attribution"]) && (
            <div styleName="hero-image-wrapper">
              {story["hero-image-caption"] && (
                <figcaption styleName="image-caption" className="story-element-image-title">
                  {story["hero-image-caption"]}
                </figcaption>
              )}
              {story["hero-image-attribution"] && (
                <figcaption className="story-element-image-title">Kuva: {story["hero-image-attribution"]}</figcaption>
              )}
            </div>
          )}
          {showPopup && (
            <LightBoxImage
            story={story}
            closePopup={() => togglePopup()}
            isHeroImage={true}
          />
          )}
          {paikkakunta.length > 0 && (<div styleName="section-place">

            <Link styleName="place">{paikkakunta} </Link>
          </div>)}
          <div styleName="social-share-top">
            <SocialShareBottom story={story} />
          </div>
        </React.Fragment>
      )}

    </div>
  );
};

StoryHeader.propTypes = {
  story: object,
  sectionName: string,
  isHeroImage: bool
};

export default StoryHeader;
